module.exports = __webpack_public_path__ + "assets/img/202110-6.713b2906.png";